import { useElementRect } from "@/hooks/useElementRect";
import type { GridColorScheme } from "@skillscratch/shared-types";
import { type ReactNode, useEffect } from "react";
import { CircularLoadingSpinner } from "../CircularLoadingSpinner/CircularLoadingSpinner";
import type { ControlColorScheme } from "./Game";
import { GameGrid, type GameGridProps } from "./GameGrid/GameGrid";

export function FramedGameGrid({
  scratchable,
  grid,
  colorScheme,
  isLoading,
  bottomBar,
  onSquareReveal,
  onRectChange,
}: GameGridProps & {
  colorScheme: GridColorScheme & ControlColorScheme;
  isLoading?: boolean;
  bottomBar?: ReactNode;
  onRectChange?: (rect: DOMRect) => void;
}) {
  const [container, containerRect] = useElementRect<HTMLDivElement>();

  useEffect(() => {
    if (containerRect) {
      onRectChange?.(containerRect);
    }
  }, [containerRect, onRectChange]);

  return (
    <div
      style={{
        containerType: "inline-size",
      }}
    >
      <div
        ref={container}
        style={{
          background: colorScheme.controlColor,
          borderRadius: "2cqw",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            position: "relative",
          }}
        >
          <GameGrid
            scratchable={scratchable}
            grid={grid}
            colorScheme={colorScheme}
            onSquareReveal={onSquareReveal}
          />

          {isLoading && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                display: "grid",
                placeItems: "center",
              }}
            >
              <CircularLoadingSpinner size="10vw" fillWidth />
            </div>
          )}
        </div>
        {bottomBar && <div style={{ height: "17cqw" }}>{bottomBar}</div>}
      </div>
    </div>
  );
}
